/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TokenSetupInstructions/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import TysiaTextarea from 'DesignSystem/TysiaTextarea/index'
import TysiaTextareaContent from 'DesignSystem/TysiaTextarea/TysiaTextareaContent/index'
import TysiaTextareaField from 'DesignSystem/TysiaTextarea/TysiaTextareaField/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TokenSetupInstructions({
  children,
  viewPath = "/App/Account/Content/Settings/AdminContent/SettingsContent/PaymentProviders/AddAction/Content/Content/Payabli/TokenSetupInstructions"
  
}) {
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let globalCurrentLocationParentCompanyNameValueData = fromData.useDataValue({ viewPath,
context: 'global',
path: 'current_location.parent_company.name',
})
let selectedTextValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'text',
})
let selectedIdValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'id',
})
let aggregateData = fromHelpers.getDescription(globalCurrentLocationParentCompanyNameValueData, selectedTextValueData, selectedIdValueData)
  return (<React.Fragment
>
<div
  data-testid="TokenSetupInstructions.Vertical"
  data-view-path={viewPath}
 style={{'--bc-1-Z1D3OVJ': dtColorsWhite,'--mt-2-Z1D3OVJ': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pl-3-Z1D3OVJ': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-4-Z1D3OVJ': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pb-5-Z1D3OVJ': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pt-6-Z1D3OVJ': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="semibold"
 text="Instructions to set up PayPoint API token for a location"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Some locations may share a PayPoint entryPoint ID. All locations must have their own API token."
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginTop={dtSpaceXs}
 text="• On Payabli portal, go to Developers > API Tokens > Create API Token"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="• Token mode: Private"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="• Token type: Organization"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="• Token lifetime: 24 months"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="• Allowed IP Addresses: Leave blank"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="• Creator token: No"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="• Description:"
/>
<TysiaTextarea
  viewPath={`${viewPath}/TysiaTextarea`}
 marginTop={0}
 disabled={true}
 data="global.current_location.parent_company.name"
 data="selected.text"
 data="selected.id"
 aggregate="helpers.js getDescription"
 value={aggregateData}
>
{childProps => (
<TysiaTextareaContent
{...childProps}
  viewPath={`${viewPath}/TysiaTextareaContent`}
>
{childProps => (
<TysiaTextareaField
{...childProps}
  viewPath={`${viewPath}/TysiaTextareaField`}
/>
)}
</TysiaTextareaContent>
)}
</TysiaTextarea>
</div>
{children}
</React.Fragment>)
}